import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "product-counter"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonControl = _resolveComponent("ButtonControl")!
  const _component_button_control = _resolveComponent("button-control")!
  const _component_counter = _resolveComponent("counter")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["b24-btn-wrap", _ctx.buttonClasses])
  }, [
    (_ctx.productType === 'checkout')
      ? (_openBlock(), _createBlock(_component_ButtonControl, {
          key: 0,
          disabled: _ctx.isLoading,
          loading: _ctx.isLoading,
          "is-block": true,
          size: "small",
          onClick: _withModifiers(_ctx.handleAddToBasket, ["prevent"])
        }, {
          default: _withCtx(() => [
            (_ctx.currentQuantity === 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.basketButtonTitle), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.orderButtonTitle), 1)
                ], 64))
          ]),
          _: 1
        }, 8, ["disabled", "loading", "onClick"]))
      : (_ctx.productType === 'preorder')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.withCounter)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_button_control, {
                    class: "product-counter__button",
                    size: "small",
                    disabled: _ctx.isLoading,
                    loading: _ctx.isLoading,
                    onClick: _ctx.handlePreorder
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.orderButtonTitle), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading", "onClick"]),
                  _createVNode(_component_counter, {
                    modelValue: _ctx.count,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.count) = $event)),
                    size: "small",
                    class: "product-counter__counter",
                    "min-value": 1,
                    "max-value": 999
                  }, null, 8, ["modelValue"])
                ]))
              : (_openBlock(), _createBlock(_component_ButtonControl, {
                  key: 1,
                  disabled: _ctx.isLoading,
                  loading: _ctx.isLoading,
                  "is-block": true,
                  size: "small",
                  onClick: _ctx.handlePreorder
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.orderButtonTitle), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "loading", "onClick"]))
          ], 64))
        : _createCommentVNode("", true)
  ], 2))
}